import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('sections', ['firstSection']),
  },

  methods: {
    back() {
      this.$store.commit('setError403', false)
      this.$store.commit('setError404', false)
      this.$router.push({
        name: 'Sessions',
        params: { slug: this.firstSection },
      })
    },
  },
}
